import React from 'react';
import { useNavigate } from 'react-router-dom';

interface BotaoVoltarProps {
  className?: string;
}

const BotaoVoltar: React.FC<BotaoVoltarProps> = ({ className }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/milshop');
  };

  return (
    <button onClick={handleBackClick} className={`btn btn-warning me-2 ${className}`}>
      Voltar
    </button>
  );
};

export default BotaoVoltar;
